import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import HomePage    from "./HomePage";
import Datenschutz from "./Datenschutz";
import Danke       from "./Danke";
import CustomerSelectionPage from "./CustomerSelectionPage";

export default function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        {/* Auswahlseite - Hauptdomain ohne Anhang */}
        <Route path="/" element={<CustomerSelectionPage />} />
        
        {/* Privatkunden-Seite */}
        <Route path="/privatkunden" element={<HomePage />} />
        
        {/* Geschäftskunden-Seite */}
        <Route path="/geschaeftskunden" element={<HomePage />} />
        
        {/* Weitere Seiten */}
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/danke" element={<Danke />} />
        
        {/* Redirect /select zu / */}
        <Route path="/select" element={<Navigate to="/" replace />} />
        
        {/* Fallback: unbekannte Pfade → Auswahlseite */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

